import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GROUP_ORDER_EVENTS from 'bento-ordering/group_ordering/constants/streamEvents';
import { selectCartGroupOrderSlug } from 'bento-ordering/cart/selectors';
import getThrottleFetchFunction from 'helpers/getThrottleFetchFunction';
import { fetchGroupOrder } from 'bento-ordering/group_ordering/actions/index';

const useSubscribeToGroupOrderEvents = () => {
  const dispatch = useDispatch();
  const groupOrderSlug = useSelector(selectCartGroupOrderSlug);

  const throttleFetchData = getThrottleFetchFunction(() =>
    dispatch(fetchGroupOrder(groupOrderSlug))
  );

  const subscribeToGroupOrderEvents = subscribeToEvent => {
    GROUP_ORDER_EVENTS.forEach(groupOrderEvent =>
      subscribeToEvent(groupOrderEvent, () => throttleFetchData())
    );
  };

  useEffect(() => {
    return () => throttleFetchData.cancel?.();
  }, [throttleFetchData]);

  return {
    subscribeToGroupOrderEvents
  };
};

export default useSubscribeToGroupOrderEvents;
